import { render, staticRenderFns } from "./AgileOctopus.vue?vue&type=template&id=f4d0b5b8"
import script from "./AgileOctopus.vue?vue&type=script&lang=ts"
export * from "./AgileOctopus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports